export const ASTRONAUTS = 'ASTRONAUTS-22c98a';